import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get, throttle } from 'lodash'
import styles from './content.styl'

export default class MaterialModalContent extends Component {
  static propTypes = {
    children: PropTypes.any,
    noHeader: PropTypes.bool,
    noFooter: PropTypes.bool,
    minimal: PropTypes.bool
  }

  static defaultProps = {
    noHeader: false,
    noFooter: false
  }

  constructor() {
    super()
    this.isScrollable = throttle(this.isScrollable, 50)
    this.component = {}
  }

  isScrollable = () =>
    get(this.component, 'scrollHeight') > get(this.component, 'clientHeight')

  render() {
    const { noFooter, noHeader, minimal } = this.props
    const classNames = [styles.content]

    noFooter && classNames.push(styles.noFooter)
    noHeader && classNames.push(styles.noHeader)
    minimal && classNames.push(styles.minimal)

    if (this.isScrollable()) {
      classNames.push(styles.scrollable)
    }

    return (
      <div className={classNames.join(' ')} ref={c => this.component = c}>
        <div className={styles.bottomSpace}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
